<template>
  <div class="batch-linked-question-modal">
    <TitleBaseBox :title="data.title" :noButton="true" @close="close" class="linked-question-box">
      <AssociateQuery :modalData="data" />
      <div class="selected-linked-question-btn">
        <RelationQuesBar :currentLang="currentLang" class="linked-content-operate-bar" @assignmentValue="assignmentValue" @getBatchQuestionList="getBatchQuestionList" @langChange="langChange"/>
        <RoundButton class="btn" :text="searchText" @btnClick="SearchHandler"/>
      </div>
    </TitleBaseBox>
  </div>
  
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import RelationQuesBar from "./RelationQuesBar.vue";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import AssociateQuery from "./AssociateQuery";
import i18n from "@/i18n";
export default {
  name: "BatchLinkedQuesModal",
  props: ["data"],
  components:{
    TitleBaseBox,
    RelationQuesBar,
    RoundButton,
    AssociateQuery
  },
  data() {
    return {
      inputVal: "",
      tableData: [],
      standTotal: "",
      requestObj: {},
      currentLang: this.data.currentLang || "all",
      batchAssociationLang: null
    }
  },
  computed: {
    searchText() {
      return this.$t("zhiji.common.search");
    },
  },
  methods: {
    showTipsModal(message){
      this.$message({
        message: message,
        center: true,
        duration: 2000,
        type: "warning"
      });
    },
    close() {
      this.$store.dispatch("zhiji/hideModal", "BatchLinkedQuesModal");
    },
    assignmentValue(data) {
      this.inputVal = data;
    },
    langChange(lang) {
      this.batchAssociationLang = lang;
    },
    getBatchQuestionList(reqData) {
      this.requestObj = Object.assign({}, this.requestObj, reqData);
        this.zhiji.requestByServiceName("queryQuestionList", { ...this.requestObj, size: 10 }).then(res => {
          this.tableData = res.dataset;
          this.standTotal = res.standTotal;
      });
    },
    SearchHandler() {
      if (!this.inputVal) {
        this.showTipsModal(this.$t("zhiji.common.enterKeyWordError"));
        return;
      }
      setTimeout(() => { //防止数据请求未完成就关闭弹框
        this.$store.dispatch("zhiji/hideModal", "BatchLinkedQuesModal");
        this.$store.dispatch("zhiji/showModal", {
          type: "CorrelateSimilarQuesModal",
          data: {
            ...this.data, 
            title: i18n.t("zhiji.cluster.closeLoop.linkSimilar"),
            batchTableData: this.tableData,
            batchStandTotal: this.standTotal,
            requestObj: this.requestObj,
            batchAssociationLang:this.batchAssociationLang,
          }
        });
      },500);
    },
  }

}
</script>
<style lang="less" scoped>
.batch-linked-question-modal {
  height: 100%;
  width: 100%;
  background: rgba(65, 71, 94, 0.4);
  display: flex;
  align-items: center;
  justify-content: space-around;
  .linked-question-box {
      width: 900px;
  }
  /deep/.base-content {
    padding: 0 80px 20px 80px;
  }
  /deep/ .i-search {
    display: none;
  }
  /deep/ .i-s-del {
    right: 10px;
  }
  .selected-linked-question-btn {
    height: 235px;
    .btn {
      border-radius: 5px;
      font-size: 12px;
      margin-right: 0;
    }
  }
}

</style>